/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} HardcoverInputs */

const en_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardcover`)
};

const es_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tapa dura`)
};

const fr_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couverture rigide`)
};

const de_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hardcover`)
};

const ja_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハードカバー`)
};

const zh_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精装版`)
};

const ar_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`غلاف مقوى`)
};

const id_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sampul Keras`)
};

const it_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copertina Rigida`)
};

const ru_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Твердая Обложка`)
};

const pt_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capa Dura`)
};

const ko_hardcover = /** @type {(inputs: HardcoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하드커버`)
};

/**
* | output |
* | --- |
* | "Hardcover" |
*
* @param {HardcoverInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hardcover = /** @type {((inputs?: HardcoverInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<HardcoverInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hardcover(inputs)
	if (locale === "es") return es_hardcover(inputs)
	if (locale === "fr") return fr_hardcover(inputs)
	if (locale === "de") return de_hardcover(inputs)
	if (locale === "ja") return ja_hardcover(inputs)
	if (locale === "zh") return zh_hardcover(inputs)
	if (locale === "ar") return ar_hardcover(inputs)
	if (locale === "id") return id_hardcover(inputs)
	if (locale === "it") return it_hardcover(inputs)
	if (locale === "ru") return ru_hardcover(inputs)
	if (locale === "pt") return pt_hardcover(inputs)
	return ko_hardcover(inputs)
});